module.exports = __webpack_public_path__ + "media/images/emblems/Belp-coat_of_arms-f29ca80bd6a9d7a591094a12222c8689.svg";